import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from '../inc/header';
import Footer from '../inc/footer';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { useParams, useNavigate } from 'react-router-dom';

function ServiceDetail() {
    const { slug } = useParams();
    const navigate = useNavigate();

    const [JobDetails, setJobDetails] = useState(null);
    const [JobName, setJobName] = useState("");
    const [JobType, setJobType] = useState("");
    const [Location, setLocation] = useState("");
    const [loading, setLoading] = useState(true);

    const fetchProductDetails = async () => {
        setLoading(true);

        try {
            const response = await fetch(
                `https://crmradius.gemsdrive.co.uk/public/api/get_career_details/${slug}`
            );

            if (!response.ok) {
                navigate("/NotFound");
                return;
            }

            const result = await response.json();
            console.log("🔍 API Response:", result);

            const job = result?.job?.[0];

            if (!job) {
                navigate("/NotFound");
                return;
            }

            setJobDetails(job?.description ?? null);
            setJobName(job?.job_title ?? "");
            setJobType(job?.job_type ?? "");
            setLocation(job?.location ?? "");

        } catch (error) {
            console.error("❌ Error fetching job details:", error);
            navigate("/NotFound");
        } finally {
            setLoading(false);
        }
    };

    // ✅ Now HOOK is OUTSIDE
    useEffect(() => {
        fetchProductDetails();
    }, [slug]);

    // ✅ LOADING UI
    if (loading) {
        return <p className="text-center mt-5">Loading...</p>;
    }

    // ✅ NO DATA FOUND
    if (!JobDetails) {
        return <p className="text-center mt-5 text-danger">No details found.</p>;
    }
    return (
        
        <>
             
            <Helmet>
                <title>Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company | {JobName}</title>
                <meta name="description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
                <meta property="og:title" content="Radius - Career Details" />
                <meta property="og:description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
            </Helmet>

            <Header />

            <main role="main" className="main">

                {/* ======= PAGE HEADER ======= */}
                <section
                    className="page-header page-header-modern page-header-background page-header-background-md overlay overlay-color-dark overlay-show overlay-op-7"
                    style={{
                        backgroundImage: "url('/assets/img/slides/page-header-services.jpg')",
                    }}
                >
                    <div className="container">
                        <div className="row mt-5">
                            <div className="col-md-12 align-self-center p-static order-2 text-center">
                                <h1 className="text-10">
                                    <strong>{JobName}</strong>
                                </h1>
                            </div>
                            <div className="col-md-12 align-self-center order-1">
                                <ul className="breadcrumb breadcrumb-light d-block text-center">
                                   
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <hr className="m-0" />
                <div className="container py-5 mt-3">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="overflow-hidden mb-2">
                            <h2 className="font-weight-normal text-7 mb-2" >Find Your <strong className="font-weight-extra-bold text-pink">Opportunity</strong></h2>
                            </div>
                            <div className="overflow-hidden mb-4">
                            <p className="lead mb-0" >Explore roles that let you grow, innovate, and make a meaningful impact.</p>
                            </div>
                        <p className="text-color-light-3 mb-4" >We believe in creating a culture where people can thrive—where ideas matter,
                            growth is encouraged, and every team member contributes to shaping the future
                            of our organization. Join a workplace that values passion, collaboration,
                            and continuous learning.</p>
                        </div>
                        <div className="col-lg-4">
                        <div className="testimonial testimonial-primary bg-pink" >
                            <blockquote className='bg-pink'>
                                <p className="mb-0">Your next big opportunity starts with the courage to explore something new. Let's build your future together</p>
                            </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
                 
                <section className="section section-default border-0 m-0">
                    <div className="container py-4">
                        <div className="row pb-4">
                            {/* LEFT CONTENT */}
                            <div className="col-md-8">

                                <div className="card card-default mb-2">
                                    <div className="card-header">
                                        <h4 className="card-title m-0 text-justify">
                                            {JobName} - {JobType}
                                        </h4>
                                    </div>

                                    <div className="collapse show">
                                        <div className="card-body mt-3">
                                            <div className="service-description text-justify">
                                                <div
                                                    className="service-description text-left"
                                                    dangerouslySetInnerHTML={{ __html: JobDetails }}
                                                />
                                            </div>
                                            <ul className="list list-inline mt-4 mb-3 text-2 text-justify">
                                                <li className="list-inline-item">
                                                    <strong>LOCATION:</strong> {Location}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT CONTENT */}
                            <div className="col-md-4">
                                <form
                                    id="contactFormAdvanced"
                                    method="POST"
                                    encType="multipart/form-data"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        // Handle form submit here
                                        console.log("Form submitted");
                                    }}
                                >
                                    <input type="hidden" name="emailSent" value="true" />
                                    <input type="hidden" name="position" value="3D Design Specialist" />

                                    {/* ROW 1 */}
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <input type="text" className="form-control text-3 h-auto py-2" name="name" placeholder='Full Name' required />
                                        </div>

                                        <div className="form-group col-md-6">
                                            <input type="email" className="form-control text-3 h-auto py-2" name="email" placeholder='Email Address' required />
                                        </div>

                                        <div className="form-group col-md-12">
                                            <input type="tel" className="form-control text-3 h-auto py-2" name="phone" placeholder='Contact Number' required />
                                        </div>
                                    </div>

                                    {/* ATTACHMENTS */}
                                    <div className="row">
                                        <div className="form-group col-md-12">
                                            <label className="form-label mb-1 text-2">Upload CV *</label>
                                            <input className="form-control d-block" type="file" name="cv" accept=".pdf,.doc,.docx" required />
                                            <small className="text-muted">Accepted formats: PDF, DOC, DOCX</small>
                                        </div>
                                    </div>

                                    {/* MESSAGE */}
                                    <div className="row">
                                        <div className="form-group col-md-12 mb-4">
                                            <textarea rows="6" className="form-control text-3 h-auto py-2" name="message" maxLength="5000" placeholder="Tell us why you're a good fit for this position..." />
                                        </div>
                                    </div>

                                    {/* SUBMIT */}
                                    <div className="row">
                                        <div className="form-group col-md-12 mb-5">
                                            <button
                                                type="submit"
                                                id="contactFormSubmit"
                                                className="btn btn-pink btn-modern w-100"
                                            >
                                                Apply Now
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}

export default ServiceDetail;
